import { Component, OnDestroy } from '@angular/core';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { UntypedFormControl, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AuthService } from '../auth.service';
import { Observable, BehaviorSubject, fromEvent, merge, Subscription } from 'rxjs';
import localforage from 'localforage';
import { SearchCountryField, CountryISO, PhoneNumberFormat, NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { map } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { AlertComponent } from 'ngx-bootstrap/alert';
import { NgOptimizedImage, AsyncPipe } from '@angular/common';
import { FlexModule } from '@angular/flex-layout/flex';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatIcon } from '@angular/material/icon';


@Component({
    selector: 'app-sign-in',
    templateUrl: './sign-in.component.html',
    styleUrls: ['./sign-in.component.scss'],
    imports: [
        NgOptimizedImage,
        FormsModule,
        ReactiveFormsModule,
        NgxIntlTelInputModule,
        FlexModule,
        MatProgressSpinner,
        MatIcon,
        RouterLink,
        RouterLinkActive,
        AsyncPipe,
    ],
})
export class SignInComponent implements OnDestroy {
  separateDialCode = false;
	SearchCountryField = SearchCountryField;
	CountryISO = CountryISO;
  PhoneNumberFormat = PhoneNumberFormat;
	preferredCountries: CountryISO[] = [CountryISO.India, CountryISO.UnitedStates];
  

  // public sms = new FormControl(undefined, [Validators.required])
  signInForm = new UntypedFormGroup({
		sms: new UntypedFormControl(undefined, [Validators.required])
	});

  private busy_ = new BehaviorSubject(false);
  public busy = this.busy_.asObservable();

  private errorMessage_ = new BehaviorSubject('');
  public errorMessage = this.errorMessage_.asObservable();
  isOnline: boolean = true;
  lastSuccessfulSigninNumber = null;
  private onlineStatusSubscription?: Subscription;

  constructor(private router: Router, private auth: AuthService, private toastr: ToastrService) { }

  createOnline$() {
    return merge(
      fromEvent(window, 'offline').pipe(map(() => false)),
      fromEvent(window, 'online').pipe(map(() => true)),
      new Observable<boolean>((sub) => {
        sub.next(navigator.onLine);
        sub.complete();
      }));
  }

  ngOnInit() {
    this.onlineStatusSubscription = this.createOnline$().subscribe(isOnline => {
      if(!this.isOnline && isOnline)
        window.location.reload();
      this.isOnline = isOnline;
    });
    localforage.getItem('lastSuccessfulSigninNumber').then(event => {
      if(event && event != null){
        this.lastSuccessfulSigninNumber = event;
      }
      else{
        localforage.getItem('lastSignInNumber').then(event => {
          if(event && event != null){
            console.log("Saved Number is :", event);
            this.signInForm.controls['sms'].setValue(event);
          }
        })
          .catch(e => {
            console.log('Error saved lastSignInNumber', e);
          });
      }
    })
    .catch(e => {
      console.log('Error saved lastSuccessfulSigninNumber', e);
    });
  }

  ngOnDestroy(): void {
    this.onlineStatusSubscription?.unsubscribe();
  }

  clearLastSuccessfulSigninNumber(){
    this.lastSuccessfulSigninNumber = null;
  }

  onKeydown(event){
    event.preventDefault();
  }

  public async signInWithLastsuccessful(){
    console.log("sms is", this.lastSuccessfulSigninNumber);
    if(this.lastSuccessfulSigninNumber){
      this.busy_.next(true);
      this.errorMessage_.next('');
      try {
        let signInReposnse = await this.auth.signIn(this.lastSuccessfulSigninNumber);
        console.log("sign in response is ", signInReposnse);
        if(signInReposnse.challengeParam && signInReposnse.challengeParam["phone"]){
          localforage.setItem('lastSignInNumber', this.signInForm.controls['sms'].value);
          this.router.navigate(['/enter-secret-code'], { queryParams: { number: this.lastSuccessfulSigninNumber } });
        }else{
          let data = this.signInForm.controls['sms'].value;
          this.router.navigate(['/sign-up'], { queryParams: { ...data } });
        }
      } catch (err) {
        this.errorMessage_.next(err.message || err);
        console.log("Error Occured in Sign-In", err)
        if (err && err.code == "UserNotFoundException"){
          let data = this.signInForm.controls['sms'].value;
          this.router.navigate(['/sign-up'], { queryParams: { ...data } });
        }
      } finally {
        this.busy_.next(false);
      }
    }
  }

  public async signIn() {
    console.log("sms is", this.signInForm.controls['sms'])
    if(this.signInForm.valid && this.signInForm.controls['sms'].valid && this.signInForm.controls['sms'].value){
      this.busy_.next(true);
      this.errorMessage_.next('');
      try {
        let e164Number = this.signInForm.controls['sms'].value.e164Number;
        let signInReposnse = await this.auth.signIn(e164Number);
        console.log("sign in response is ", signInReposnse);
        if(signInReposnse.challengeParam && signInReposnse.challengeParam["phone"]){
          localforage.setItem('lastSignInNumber', this.signInForm.controls['sms'].value);
          this.router.navigate(['/enter-secret-code'], { queryParams: { number: e164Number } });
        }else{
          let data = this.signInForm.controls['sms'].value;
          this.router.navigate(['/sign-up'], { queryParams: { ...data } });
        }
      } catch (err) {
        this.errorMessage_.next(err.message || err);
        console.log("Error Occured in Sign-In", err)
        this.toastr.error("Could not sign you in, try signing up!!!")
        if (err && err.code == "UserNotFoundException"){
          let data = this.signInForm.controls['sms'].value;
          this.router.navigate(['/sign-up'], { queryParams: { ...data } });
        }
        else{
          let data = this.signInForm.controls['sms'].value;
          this.router.navigate(['/sign-up'], { queryParams: { ...data } });
        }
      } finally {
        this.busy_.next(false);
      }
    }
  }
}
